import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'
import { GroupVisibility } from 'app/types/GroupVisibility'

const query = gql`
  query searchGroups(
    $searchTerm: String
    $limit: Int
    $sort: String
    $page: Int
    $categories: [String!]
  ) {
    searchGroups(
      searchTerm: $searchTerm
      limit: $limit
      sort: $sort
      page: $page
      categories: $categories
    ) {
      totalDocs
      page
      docs {
        id
        name
        totalMembers
        visibility
        profileImage {
          id
          sizes {
            small {
              url
            }
            medium {
              url
            }
          }
        }
        university {
          slug
        }
        universityCourse {
          slug
        }
        allowedUserTypes
      }
    }
  }
`

export interface HotGroupsQueryInput {
  page: number
  searchTerm: string
  limit: number
  sort: string
  categories: string[]
}

export interface HotGroupsQueryOutput {
  searchGroups: {
    totalDocs: number
    page: number
    totalPages: number
    docs: {
      id: string
      name: string
      visibility: GroupVisibility
      totalMembers: number
      profileImage: {
        sizes: {
          small: {
            url: string
          }
          medium: {
            url: string
          }
        }
      }
      university?: {
        slug: string
      }
      universityCourse?: {
        slug: string
      }
      allowedUserTypes: string[]
    }[]
  }
}

const defaultVariables: HotGroupsQueryInput = {
  page: 1,
  sort: '-members',
  searchTerm: '',
  categories: [],
  limit: 6,
}

export const useHotGroupsQuery = (options: QueryHookOptions<HotGroupsQueryOutput, HotGroupsQueryInput>) => usePersistedCacheQuery<HotGroupsQueryOutput, HotGroupsQueryInput>(query, {
  ...options,
})

export const hotGroupsQuery = { query, defaultVariables }
